import {Directive,ElementRef,Renderer,HostListener,Input} from '@angular/core';


@Directive({ selector: '[vnptBuidOptions]' })

export class VnptBuidOptionsDirective {
    newString:string = '';
    
    @Input() set vnptBuidOptions(listItems: any) {
        this.newString  = '<option value="">--- Chọn đơn vị --</option>';
      
        this.ElementRef.nativeElement.innerHTML = "";
        this.ElementRef.nativeElement.value = null;
        var ds = listItems;
        this.createMenu(ds,0,0);
          
        this.ElementRef.nativeElement.innerHTML = this.newString;
        
    }
    constructor(private ElementRef:ElementRef, private Renderer:Renderer ){
        this.ElementRef.nativeElement.innerHTML = "";
    }

    createMenu(listItems:any,parent:number,level:number=0){                
        if(listItems.length>0){            
            level++;           
            for(let i=0;i<listItems.length;i++){
                
                if(listItems[i].IdCha==parent){
                    var newParent = listItems[i].Id;                    
                    this.newString +='<option [value]="'+listItems[i].Id+'">'+' --- '.repeat(level-1)+listItems[i].Ten;
                    //this.newString +=`<option [value]="listItems[i].Id"> " --- ".repeat(level-1)+listItems[i]`;                                          
                    this.createMenu(listItems,newParent,level);
                    this.newString= this.newString+`</option>`;
                   
                }
            }
                                 
            
        }
        
    }

}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/vnpt-buid-options.directive.ts